import { useEffect, useState } from "react";
import { api, getToken, clearToken } from "@/lib/api";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminShell from "@/components/admin/AdminShell";

export default function AdminPage() {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    if (!getToken()) {
      setAdmin(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setAdmin(r.data))
      .catch(() => { clearToken(); setAdmin(false); });
  }, []);

  if (admin === null) {
    return <div className="flex min-h-screen items-center justify-center text-sm text-mist" data-testid="admin-loading">Checking session…</div>;
  }
  if (!admin) return <AdminLogin onLogin={setAdmin} />;
  return <AdminShell admin={admin} onLogout={() => { clearToken(); setAdmin(false); }} />;
}
